import { LinkField, RichTextField, Field, ImageField } from '@sitecore-jss/sitecore-jss-nextjs';
import { ArticleFields } from 'src/shared/ArticleBase.types';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  ImagePropertiesParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type C23ContentFeedForLocalSiteProps = RenderingProps<
  C23ContentFeedForLocalSiteFields,
  C23ContentFeedForLocalSiteParams
>;

export type C23ContentFeedForLocalSiteFields = {
  ContentWithFeaturedCard?: {
    Heading?: Field<string>;
    SupportCopy?: RichTextField;
    CTA?: LinkField;
    FeaturedCards?: FeaturedCards;
    PlaceholderImage?: ImageField;
  };
};

export type FeaturedCards = {
  articles?: Array<ArticleData>;
};

export type ArticleData = {
  url?: string;
  fields?: ArticleFields;
};

export type C23ContentFeedForLocalSiteParams = {
  HeadlineTag?: string;
  ContentAlignment?: string;
  BackgroundColor?: string;
  CTAAlignment?: string;
} & DynamicPlaceholderParams &
  AnchorTargetParams &
  TranslationOptionsParams &
  ImagePropertiesParams;
